module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "lang": _vm.lesson.language
    }
  }, [_c('div', {
    staticClass: "page-title mb-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item border-left-0"
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/home.png"),
      "height": "40"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item text-left border-right-0 pl-3"
  }, [_c('a', {
    staticClass: "nav-link",
    domProps: {
      "innerHTML": _vm._s(_vm.forceToJap(_vm.lesson.name) + ' - ' + _vm.lesson.localName)
    }
  })])])])]), _vm._v(" "), (_vm.tab === 'player') ? _c('div', {
    staticClass: "container mb-3 pt-4 pb-4 bg-white"
  }, [_c('div', {
    staticClass: "container pl-3 pr-3 text-right",
    staticStyle: {
      "max-width": "720px !important",
      "min-width": "320px !important"
    }
  }, [_c('span', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goTabRecord()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/lesson_score_off.png")
    }
  }), _vm._v(" "), (false) ? _c('img', {
    attrs: {
      "src": require("../assets/image/icon/lesson_score_on.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/close_lesson.png")
    }
  })])]), _vm._v(" "), (_vm.lesson && _vm.lesson.modules.length > 0) ? _c('live-player', {
    attrs: {
      "liveData": _vm.lesson
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 'package') ? _c('div', {
    staticClass: "container mb-3 pt-4 pb-4 bg-white"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('span', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/close_lesson.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.lesson.localName))]), _vm._v(" "), _c('img', {
    staticClass: "mb-3",
    staticStyle: {
      "max-width": "60%",
      "max-height": "60%"
    },
    attrs: {
      "src": _vm.lesson.cover
    }
  }), _vm._v(" "), (_vm.lesson.introduction) ? _c('p', {
    staticClass: "introduction"
  }, [_vm._v(_vm._s(_vm.lesson.introduction))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs mb-3"
  }, [_c('li', {
    staticClass: "nav-item ml-5"
  }, [_c('a', {
    staticClass: "nav-link rounded-top",
    class: {
      'active': _vm.tab === 'package'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'package'
      }
    }
  }, [_vm._v("課程清單")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.lesson.lessons), function(lesson, index) {
    return _c('li', {
      key: lesson.id,
      staticClass: "list-group-item text-left mb-3 border-top-0 border-left-0 border-right-0"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('div', {
      staticClass: "align-items-baseline mr-auto"
    }, [_c('b', [_vm._v(_vm._s(index < 9 ? '0' + (index + 1) : (index + 1)) + ". " + _vm._s(lesson.localName))]), _vm._v(" "), _c('span', {
      staticClass: "ml-3",
      domProps: {
        "innerHTML": _vm._s(_vm.forceToJap(lesson.name))
      }
    }), _vm._v(" "), (lesson.introduction) ? _c('p', {
      staticClass: "introduction pl-4"
    }, [_vm._v(_vm._s(lesson.introduction))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center mr-3"
    }, [_c('icon-button', {
      attrs: {
        "name": "more_info",
        "alt": "開始課程"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            name: 'lesson.player',
            params: {
              lessonId: lesson.id
            }
          })
        }
      }
    })], 1)])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.tab === 'record') ? _c('div', {
    staticClass: "container mb-3 pt-4 pb-4 bg-white"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('span', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.tab = 'player'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/close_lesson.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "list-group ml-5 mr-5"
  }, [_c('li', {
    staticClass: "list-group-item d-flex justify-content-between p-0 mb-3 border-top-0 border-left-0 border-right-0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mr-auto"
  }, [_vm._v("\n            累積次數：" + _vm._s(_vm.record.learnCount) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("\n            最後更新時間：" + _vm._s(_vm.record.lastTime) + "\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item d-flex justify-content-between p-0 mb-3 border-top-0 border-left-0 border-right-0"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mr-auto"
  }, [_vm._v("\n            累積時數：" + _vm._s(_vm.record.spendTime) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("\n            最後更新時間：" + _vm._s(_vm.record.lastTime) + "\n          ")])]), _vm._v(" "), (_vm.record.practiceScore) ? _c('li', {
    staticClass: "list-group-item d-flex justify-content-between p-0 mb-3 border-top-0 border-left-0 border-right-0"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mr-auto"
  }, [_vm._v("\n            分數：" + _vm._s(_vm.record.practiceScore) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("\n            最後更新時間：" + _vm._s(_vm.record.lastTime) + "\n          ")])]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs mb-3"
  }, [_c('li', {
    staticClass: "nav-item ml-5"
  }, [_c('a', {
    staticClass: "nav-link rounded-top active"
  }, [_vm._v("本課成績")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left p-3 mr-auto"
  }, [_c('b', [_vm._v("01.本課觀看累積次數 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left p-3 mr-auto"
  }, [_c('b', [_vm._v("02.本課觀看累積時數 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left p-3 mr-auto"
  }, [_c('b', [_vm._v("03.本課測驗成績分數 ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0637475c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LessonPlayer.vue
// module id = 703
// module chunks = 1